import { useEffect, useState } from "react";
import { useVillagesHttp } from "../../hooks/useVillagesHttp";
import { Asset } from "../../data/Asset";
import { VillageDto } from "../../dtos/VillageDto";
import { FormControl, InputLabel, Select, OutlinedInput, InputAdornment, CircularProgress, MenuItem, Checkbox, ListItemText, SelectChangeEvent } from "@mui/material";
import { useCookies } from "react-cookie";


type SelectMultipleVillagesProps = {

    defaultVillages : string[ ],
    selectVillages:( villages: string[ ] ) => void

};


export const SelectMultipleVillages : React.FC< SelectMultipleVillagesProps > = ( props : SelectMultipleVillagesProps ) => {

    const { defaultVillages, selectVillages } = props;


    const [ isLoading, setIsLoading ] = useState< boolean >( true );
    const [ selectedVillages, setSelectedVillages ] = useState< string[] >( [] );
    const [ villages, setVillages ] = useState< VillageDto[ ] >( [ ] );


    const { getVillages } = useVillagesHttp( );


    const [ cookies, setCookie, removeCookie ] = useCookies( );


    useEffect( ( ) => {
        
        const fetchData = async ( ) => {

            const villages = await getVillages( Asset.Waio );
            setIsLoading( false );

            if( villages ) {
                
                setVillages( villages );

            }

        }; 

        fetchData( );

    }, [ ]);


    useEffect( ( ) => {

        if( defaultVillages.length === 0 || selectedVillages.length > 0 || villages.length === 0 ){
            
            return;

        }

        const validatedVillages = defaultVillages.filter( m => villages.map( c => c.villageCode ).includes( m ) ); // check if the status actually exists
        
        setSelectedVillages( validatedVillages ); 
        setCookie( 'card-swap-villages', JSON.stringify( validatedVillages ) );

        
    }, [ villages, defaultVillages ]);


    
    const handleVillagesChange = ( event: SelectChangeEvent<typeof selectedVillages> ) => {

        const value = event.target.value;

        const newSelectedVillages = typeof value === 'string' ? value.split( ',' ) : value; // On autofill we get a stringified value

        setSelectedVillages( newSelectedVillages );

        selectVillages( newSelectedVillages ); 

    };


    return(
        
        <FormControl sx={{ width: '429px' }}>
        <InputLabel>Villages</InputLabel>
        <Select
            multiple
            value={ selectedVillages }
            onChange={ handleVillagesChange }
            input={ <OutlinedInput label="Villages" /> }
            renderValue={ selected => villages.filter( village => selected.includes( village.villageCode ) ).map( x => x.villageName ).join( ', ' ) }
            endAdornment={
                isLoading
                    &&
                <InputAdornment position="end">
                  <CircularProgress size={ 30 } sx={{ backgroundColor : 'white' }} />
                </InputAdornment>
            }
         >
            { villages.map( village => (
                <MenuItem key={village.villageCode} value={village.villageCode}>
                    <Checkbox checked={ selectedVillages.indexOf( village.villageCode ) > -1 } />
                    <ListItemText primary={ village.villageName } />
                </MenuItem>
            ))}
         </Select>
     </FormControl>

    );

};